function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), React.createElement("path", {
  d: "M168 262L44 390c-26 27-25 70 2 95 26 26 69 25 95-1l124-129 129 124c27 26 69 25 95-1 26-27 25-70-2-95L358 258l125-129c25-26 25-69-2-95-26-25-69-25-95 2L262 165 133 41c-27-26-69-25-95 1-26 27-25 70 2 95z"
})));